import { Component, OnInit, inject } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { saveAs } from '@progress/kendo-file-saver';
import { DateTime } from 'luxon';
import { catchError } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { EnvironmentService } from '../../../services/environment.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-death-benefits',
  templateUrl: './death-benefits.component.html',
  styleUrls: ['./death-benefits.component.scss'],
  imports: [NgxLoadingModule, MatCardModule, MatButtonModule, MatIconModule],
  providers: [],
})
export class DeathBenefitsComponent implements OnInit {
  private dbs = inject(DashboardService);
  private pltfrm = inject(Platform);
  private envSvc = inject(EnvironmentService);

  private environment;
  public benefits: Array<object>;
  public expiring: Array<object>;
  public updating: Array<object>;
  state = 'start';
  private baseUrl: string;

  GetClass(startDate: string, expireDate: string): string {
    const start = DateTime.fromJSDate(new Date(startDate)).toUTC();
    const expire = DateTime.fromJSDate(new Date(expireDate)).toUTC();
    if (
      expire >= DateTime.now().minus({ days: 1 }).toUTC() &&
      expire <= DateTime.now().plus({ days: 1 }).toUTC()
    ) {
      return 'ExpiringTomorrow';
    }
    if (
      expire >= DateTime.now().minus({ days: 1 }).toUTC() &&
      expire <= DateTime.now().plus({ days: 7 }).toUTC()
    ) {
      return 'ExpiringSoon';
    }
    if (
      start >= DateTime.now().toUTC() &&
      start <= DateTime.now().plus({ days: 1 }).toUTC()
    ) {
      return 'EffectiveToday';
    }
    if (
      start >= DateTime.now().toUTC() &&
      start <= DateTime.now().plus({ days: 7 }).toUTC()
    ) {
      return 'EffectiveSoon';
    }
    return '';
  }

  download(): void {
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    this.dbs.getDashboardAnnuitiesCsv('deathbenefits').subscribe(data => {
      const filename = `death_benefits.csv`;

      let fileData;
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData, filename, {
          proxyURL: `${this.baseUrl}/util/proxy`,
          proxyTarget: '_self',
          forceProxy: iosSafari,
        });
      };
    });
  }

  ngOnInit(): void {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
  }

  load(): void {
    this.state = 'loading';
    this.expiring = [];
    this.updating = [];
    this.dbs.getDashboardAnnuities('deathbenefits').subscribe({
      next: x => {
        this.updating = x['updating']['data'].slice(0, 10);
        this.expiring = x['expiring']['data'].slice(0, 10);
        this.state = this.updating.length ? 'loaded' : 'none';
      },
      error: e => {
        this.expiring = [];
        this.updating = [];
        this.state = 'none';
        catchError(e);
      },
    });
  }
}
